import urls from "global/constants/UrlConstants";
import { getCallParams, getFileCallParams, makeCall } from "utils/service";

export interface BrandingSettings {
  name: string;
  appUrl: string;
  logoUrl: string;
  primaryColor: string;
  buttonTextColor: string;
  backgroundColor: string;
  footerText: string;
  senderEmail: string;
  senderName: string;
  enabled: boolean;
}

const emptyBrandingSettings = (): BrandingSettings => ({
  name: "",
  appUrl: "",
  logoUrl: "",
  primaryColor: "#DC4313",
  buttonTextColor: "#FFFFFF",
  backgroundColor: "#F3F4F6",
  footerText: "",
  senderEmail: "",
  senderName: "",
  enabled: false,
});

/** The stored branding row (GET branding, or the embedded editor's bundle) as the settings shape. */
export const toBrandingSettings = (response: any): BrandingSettings => {
  if (response == null) {
    return emptyBrandingSettings();
  }
  return {
    name: response?.name || "",
    appUrl: response?.appUrl || "",
    logoUrl: response?.logoUrl || "",
    primaryColor: response?.primaryColor || "#DC4313",
    buttonTextColor: response?.buttonTextColor || "#FFFFFF",
    backgroundColor: "#F3F4F6",
    footerText: response?.footerHtml || "",
    senderEmail: response?.senderEmail || "",
    senderName: response?.senderDisplayName || "",
    enabled: response?.enabled ?? false,
  };
};

export const fetchBrandingSettings = async (): Promise<BrandingSettings> => {
  try {
    const url = urls.GET_BRANDING_SETTINGS;
    const callParams = await getCallParams("GET");

    const response: any = await makeCall(url, callParams);

    return toBrandingSettings(response);
  } catch (error: any) {
    if (error?.status === 404 || error?.statusCode === 404) {
      return emptyBrandingSettings();
    }
    throw error;
  }
};

export const updateBrandingSettings = async (settings: BrandingSettings) => {
  try {
    const url = urls.UPDATE_BRANDING_SETTINGS;
    const body = {
      name: settings.name,
      appUrl: settings.appUrl,
      senderEmail: settings.senderEmail,
      senderDisplayName: settings.senderName,
      logoUrl: settings.logoUrl,
      primaryColor: settings.primaryColor,
      buttonTextColor: settings.buttonTextColor,
      footerHtml: settings.footerText,
      enabled: settings.enabled,
    };

    const callParams = await getCallParams("PUT", body);
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const uploadBrandingLogo = async (file: FormData) => {
  try {
    const url = urls.UPLOAD_BRANDING_LOGO;
    const callParams = await getFileCallParams("POST", file);
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
